import React from 'react';

import FileUpload from '../editor/FileUpload'
import Search from '../editor/Search'
import Link from '../editor/Link'

const BlogerEditor = props => {
	return (
		<div>
			{props.children}
			<Search />
			<hr />
			<div className="form-group">
				<label className="col-sm-3 control-label">Autor (imię i nazwisko)</label>
				<div className="col-sm-9">
					<input type="text" name="blog_author" className="form-control" defaultValue={props.settings.blog_author} placeholder="" />
				</div>
			</div>
			<Link value={props.settings.link} />
			<div className="form-group">
				<label className="col-sm-3 control-label">Tytuł</label>
				<div className="col-sm-9">
					<input type="text" name="title_normal" className="form-control" defaultValue={props.settings.title_normal} placeholder="" />
				</div>
			</div>
			<div className="form-group">
				<label className="col-sm-3 control-label">Treść z bloga</label>
				<div className="col-sm-9">
					<textarea rows="3" name="blog_text" className="form-control" defaultValue={props.settings.blog_text} placeholder="" />
				</div>
			</div>
		</div>
	);
}

export default BlogerEditor;